import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { ACCEPTED_FILE_TYPES } from 'config/accepted-file-types';
import Dropzone from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import DocumentPreview from 'components/modules/shipments/stops/DocumentPreview';
import { DocumentIcon } from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';
export const FileUploader = forwardRef(({ onChange, fileTypes = ACCEPTED_FILE_TYPES, fileTypesLabel, multiple = false, }, ref) => {
    const { t } = useTranslation();
    const [files, setFiles] = useState([]);
    useImperativeHandle(ref, () => {
        return {
            clearFiles: () => setFiles([]),
        };
    }, []);
    const onDrop = (newFiles) => {
        setFiles(newFiles);
        onChange === null || onChange === void 0 ? void 0 : onChange(newFiles);
    };
    const removeFile = (id) => {
        const newFiles = files.filter((file) => file.preview !== id);
        setFiles(newFiles);
        onChange === null || onChange === void 0 ? void 0 : onChange(newFiles);
    };
    const renderPreview = () => {
        const filePreviews = files.map((file, index) => {
            return (React.createElement("div", { className: "flex items-center gap-1", key: index },
                React.createElement(DocumentIcon, { className: "h-4" }),
                React.createElement(DocumentPreview, { url: file.preview, type: file.type, name: file.name, useFileName: true, handleRemove: (id) => removeFile(id), removeIconStyles: {
                        color: 'red',
                        position: 'block',
                        cursor: 'pointer',
                        marginLeft: '5px',
                        alignSelf: 'center',
                    } })));
        });
        return React.createElement("div", { className: "flex flex-col gap-2" }, filePreviews);
    };
    return (React.createElement(React.Fragment, null,
        files.length > 0 && React.createElement("div", { className: "mb-4" }, renderPreview()),
        React.createElement(Dropzone, { style: {
                width: '100%',
            }, onDropAccepted: (files) => onDrop(files), multiple: multiple, accept: fileTypes },
            React.createElement("div", { className: "flex items-center justify-end w-full" },
                React.createElement("label", { htmlFor: "dropzone-file", className: "flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50" },
                    React.createElement("div", { className: "flex flex-col items-center justify-center pt-5 pb-6" },
                        React.createElement("svg", { className: "w-10 h-10 mb-3 text-gray-400", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
                            React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" })),
                        React.createElement("p", { className: "mb-2 text-sm text-gray-500" }, t('CLICK_TO_UPLOAD_OR_DRAG_AND_DROP')),
                        fileTypesLabel && (React.createElement("p", { className: "text-xs text-gray-500" }, fileTypesLabel))))))));
});
FileUploader.propTypes = {
    onChange: PropTypes.func,
    fileTypes: PropTypes.string,
    fileTypesLabel: PropTypes.string,
    multiple: PropTypes.bool,
};
